import * as React from 'react';
import { AutoCompleteSingleInput, IAutoCompleteOption, IAutoCompleteProps } from '@rocketmakers/armstrong';
import { useDebounce } from '../hooks/useDebounce';
import { useAddressAutocompleteLookup, mapAddressSuggestionsToOptions } from '../services/addressLookupService';

type IAutoCompleteAddressInput = Partial<IAutoCompleteProps<IAutoCompleteOption>> & {
  onChange?: (value: IAutoCompleteOption) => void;
  'data-qa'?: string;
};

export const AutoCompleteAddressInput: React.FunctionComponent<IAutoCompleteAddressInput> = ({
  onChange,
  'data-qa': dataQa,
  ...autoCompleteProps
}) => {
  const [filter, setFilter] = React.useState<string>('');
  const [options, setOptions] = React.useState<IAutoCompleteOption[]>([]);
  const [loading, setLoading] = React.useState<boolean>(false);

  const resetDebounce = useDebounce(700);

  const addressAutocompleteLookup = useAddressAutocompleteLookup();

  const handleFilterChange = (value: string) => {
    const setDropdownOptions = async () => {
      const addresses = await addressAutocompleteLookup(value);

      setLoading(false);
      setOptions(mapAddressSuggestionsToOptions(addresses));
    };

    if (value.length > 1) {
      if (loading !== true) {
        setLoading(true);
      }
      resetDebounce(setDropdownOptions);
    }
    setFilter(value);
  };

  return (
    <div data-qa={dataQa ?? 'address-input'}>
      <AutoCompleteSingleInput
        filter={filter}
        options={options}
        placeholder="Start typing to find an address"
        onFilterChange={handleFilterChange}
        isSearching={loading}
        {...autoCompleteProps}
        onValueChange={value => {
          if (onChange) {
            onChange(value);
          }
          autoCompleteProps.onValueChange(value);
        }}
      />
    </div>
  );
};
